import { render, staticRenderFns } from "./c_ueditor_box.vue?vue&type=template&id=7fad890c&scoped=true"
import script from "./c_ueditor_box.vue?vue&type=script&lang=js"
export * from "./c_ueditor_box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fad890c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fad890c')) {
      api.createRecord('7fad890c', component.options)
    } else {
      api.reload('7fad890c', component.options)
    }
    module.hot.accept("./c_ueditor_box.vue?vue&type=template&id=7fad890c&scoped=true", function () {
      api.rerender('7fad890c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_ueditor_box.vue"
export default component.exports